import { Promise } from 'es6-promise';
import Api from '../../shared/Api';
import { ICreateOrder } from './Entities';
import { OrdersQuery } from './list/brokerAgentOrderList/v2/types';


export type CreateOrderResult = {
    orderCollectionId: number;
    planOrderId?: number;
    photoOrderId?: number;
    stylingOrderId?: number;
    showcaseOrderId?: number;
    digitalStylingOrderId?: number;
    isMeasured: boolean;
}

export type ICloneBatchResult = {
    createdOrderIds: number[];
    createdOrderCollectionIds: number[];
}

export type ISelectOption = {
    id: number;
    name: string;
}

export type ICloneOrderCopyDetails = {
    notes: string;
    objectAreaSquareMeters: string;
    objectNumberOfRooms: string;
    objectYearOfConstruction: string;
    objectType: number;
    apartmentHasBalcony: boolean | null;
    apartmentFloor: string;
    apartmentAccessCode: string;
    orderCollectionName: string;
}

export type ICloneOrderSourceDetails = ICloneOrderCopyDetails & {
    isCommercial: boolean;
    availablePrivateObjectTypes: ISelectOption[];
    availableCommercialObjectTypes: ISelectOption[];
}

class OrdersApi {
    static getOrders(): Promise<any> {
        return new Api().get('/views/orders');
    }

    static getOrdersV2(start: string, end: string): Promise<OrdersQuery> {
        return new Api().get('/views/orders/v2', {
            start,
            end
        });
    }

    static newOrder(
        pendingOrderId?: string,
        orderCollectionId?: number,
        newPendingOrder?: boolean
    ): Promise<any> {
        if (pendingOrderId || orderCollectionId) {
            return new Api().get('/views/orders/new', {
                pendingOrderId,
                orderCollectionId,
                newPendingOrder
            });
        }
        return new Api().get('/views/orders/new');
    }

    static cloneOrder(orderId: number): Promise<any> {
        return new Api().get('/views/orders/clone', {
            orderId
        });
    }

    static newOrderProducts(firmId: number): Promise<any> {
        return new Api().get(`/views/orders/new/products?firmId=${firmId}`);
    }

    static createOrder(
        order: ICreateOrder,
        onlyValidate: boolean,
        orderCollectionId?: number
    ): Promise<CreateOrderResult> {
        order.onlyValidate = onlyValidate;
        return new Api().post(
            '/views/orders' + (orderCollectionId ? '?orderCollectionId=' + orderCollectionId : ''),
            order
        );
    }

    static getAgreement(agreementKey: number): Promise<any> {
        return new Api().get(`/views/orders/agreements/${agreementKey}`);
    }

    static checkIfOrderIsArchived(orderId: number): Promise<any> {
        return new Api().get(`/views/orders/${orderId}/checkisarchived`);
    }

    static getPlanOrders(): Promise<any> {
        return new Api().get('/views/orders-list/plan');
    }

    static getPhotoOrders(year: number, month: number, day: number): Promise<any> {
        return new Api().get(`/views/orders-list/photo?year=${year}&month=${month}&day=${day}`);
    }

    static getUnBookedOrders(): Promise<any> {
        return new Api().get('/views/orders-list/unbooked');
    }

    static getFilmOrders(year: number, month: number, day: number): Promise<any> {
        return new Api().get(`/views/orders-list/film?year=${year}&month=${month}&day=${day}`);
    }

    static getAdvanceSearchFilters(): Promise<any> {
        return new Api().get('/views/orders-list/advance/parameters');
    }

    static getAdvanceSearchOrders(params: any): Promise<any> {
        return new Api().get('/views/orders-list/advance', params);
    }

    static getFirmsForAdvanceSearch(name: string, brokerChainId: number): Promise<any> {
        return new Api().get('/views/orders-list/advance/firms', {
            name: name,
            brokerChainId: brokerChainId
        });
    }

    static getAgentsForAdvanceSearch(brokerChainId: number, brokerFirmId: number): Promise<any> {
        return new Api().get('/views/orders-list/advance/agents', {
            brokerChainId: brokerChainId,
            brokerFirmId: brokerFirmId
        });
    }
    static cloneBatch(
        orderId: number,
        count: number,
        copies?: ICloneOrderCopyDetails[]
    ): Promise<ICloneBatchResult> {
        return new Api().post(`/views/orders/${orderId}/clone-batch`, {
            count,
            copies
        });
    }

    static getCloneDetails(orderId: number): Promise<ICloneOrderSourceDetails> {
        return new Api().get(`/views/orders/${orderId}/clone-details`);
    }

    static connectBrokerSystem(orderId:number,contentProviderObjectId :string ,contentProviderId:number):Promise<boolean>{
        return new Api().post('/views/orders/broker-system/connect',{
            orderId: orderId,
            contentProviderObjectId: contentProviderObjectId,
            contentProviderId: contentProviderId,
        })
    }
}

export default OrdersApi;
